import React, { ReactNode } from 'react';
import { Alert } from '@ver-uds/uswds-react';
import AlertConstants from '../../../constants/AlertConstants';
import EVerifyEmail from '../../../components/Enrollment/EVerifyEmail';

const EnrollmentContent: Record<string, ReactNode> = {
  everifyUsersPrimaryText: (
    <>
      <div className="tablet:grid-col-12 desktop:grid-col-9">
        <p className="usa-intro">A company must have one Signatory and at least one Program Administrator.</p>
        <ul>
          <li>
            The <b>Signatory</b> must have authority to sign the Terms and Conditions on behalf of your company and will
            be added as the Point of Contact on the E-Verify account. The Signatory can also optionally be registered as
            a Program Administrator.
          </li>
          <li>
            <b>Program Administrators</b> have the ability to create and manage cases and user accounts, run reports,
            update account information, and unlock passwords for other user accounts.
          </li>
          <li>Sharing accounts is not allowed; all users must have their own individual user accounts.</li>
        </ul>
      </div>
      <Alert className="tablet:grid-col-12 desktop:grid-col-9 margin-bottom-2" status="info" slim>
        <Alert.Text>{AlertConstants.EVERIFY_USERS_EMPLOYER_INFO}</Alert.Text>
      </Alert>
    </>
  ),
  everifyUsersPrimaryTextMFA: (
    <>
      <div className="tablet:grid-col-12 desktop:grid-col-9">
        <p className="usa-intro">You must add one Program Administrator and one Signatory during enrollment.</p>
        <h2>Program Administrator</h2>
        <p>
          <strong>Program Administrators</strong> have the ability to manage cases and user accounts, as well as run
          reports. Sharing accounts is not allowed; all users must have their own individual user accounts.
        </p>
        <p>
          The person entered here will become a Program Administrator for this E-Verify account. Additional Program
          Administrators can be added after enrollment is complete.
        </p>
      </div>
    </>
  ),
  everifyUsersCorporatePrimaryTextMFA: (
    <>
      <div className="tablet:grid-col-12 desktop:grid-col-9">
        <p className="usa-intro">A company must designate one Corporate Administrator.</p>
        <ul>
          <li>
            Corporate Administrators have the ability to create company locations, create user accounts, perform
            queries, view reports, update account information, and unlock user accounts.
          </li>
          <li>Corporate Administrators CANNOT create, edit, or view E-Verify cases.</li>
          <li>Sharing accounts is not permitted; all users must have their own individual user accounts.</li>
        </ul>
      </div>
      <Alert className="margin-bottom-2" status="info" slim>
        <Alert.Text className="grid-col-9">{AlertConstants.EVERIFY_USERS_CORPORATE_ADMIN_INFO_MFA}</Alert.Text>
      </Alert>
      <div className="tablet:grid-col-12 desktop:grid-col-9">
        <p>
          The person entered here will become a Corporate Administrator for this E-Verify account. This Corporate
          Administrator will be responsible for adding or deleting users after enrollment is complete.
        </p>
      </div>
    </>
  ),
  pendingIntroText: (
    <>
      <p className="margin-y-3">
        We couldn’t immediately approve your enrollment in E-Verify because we were unable to verify the information you
        entered. Please contact the E-Verify Customer Support team at 888-464-4218 or email us at <EVerifyEmail />{' '}
        within five federal government workdays in order to confirm the information provided during enrollment.{' '}
        <strong>
          Do not enroll your company again in E-Verify. If you attempt to re-enroll, your enrollment may be further
          delayed.
        </strong>
      </p>
      <p className="margin-y-3">
        Thanks for signing up for E-Verify. Your participation is vital in ensuring a legal U.S. workforce. We look
        forward to hearing from you shortly to confirm your enrollment information.
      </p>
    </>
  ),
};

export default EnrollmentContent;
